const scrollType = {
    duration: 500,
    delay: 50,
    smooth: true,
    offset: -100,
  };

  export default scrollType;